import { wait } from '@/__mocks__/util/async.ts'
import { status } from '@/__mocks__/config.ts'
import {
  brandCatalog,
  brandDetails,
  brandsByImeiSupplier,
  brandPage,
  modelPage,
  modelsCatalog
} from '@/__mocks__/modules/brands/data.ts'

export default [
  {
    method: 'GET',
    path: '/brands?page=1&limit=20',
    reply: async () => {
      await wait()
      return [status.ok, brandPage]
    }
  },
  {
    method: 'GET',
    path: '/brands?limit=20',
    reply: async () => {
      await wait()
      return [status.ok, brandPage]
    }
  },
  {
    method: 'GET',
    path: '/brands/1',
    reply: async () => {
      await wait()
      return [status.ok, brandDetails]
    }
  },
  {
    method: 'POST',
    path: '/brands',
    reply: async () => {
      await wait()
      return [status.ok, brandDetails]
    }
  },
  {
    method: 'GET',
    path: '/brands/catalog',
    reply: async () => {
      await wait()
      return [status.ok, brandCatalog]
    }
  },
  {
    method: 'GET',
    path: '/brands/by-imei-supplier?paginate=false',
    reply: async () => {
      await wait()
      return [status.ok, brandsByImeiSupplier]
    }
  },
  {
    method: 'DELETE',
    path: '/brands/1',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'PATCH',
    path: '/brands/1',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'GET',
    path: '/models?limit=20',
    reply: async () => {
      await wait()
      return [status.ok, modelPage]
    }
  },
  {
    method: 'GET',
    path: '/models/catalog?brand=1',
    reply: async () => {
      await wait()
      return [status.ok, modelsCatalog]
    }
  }
]
